import { createSelector } from 'reselect';

const selectGlobalShipXAgencyMappings = (state: any) => state.GlobalShipXAgencyMappings;


export const selectGlobalShipXAgencyMappingsCurrentItem = createSelector([selectGlobalShipXAgencyMappings], (GlobalShipXAgencyMappings) => GlobalShipXAgencyMappings.current);

export const selectGlobalShipXAgencyMappingsListItems = createSelector([selectGlobalShipXAgencyMappings], (GlobalShipXAgencyMappings) => GlobalShipXAgencyMappings.list);

export const selectItemById = (itemId: any) =>
    createSelector(selectGlobalShipXAgencyMappingsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectGlobalShipXAgencyMappingsQueryItems = createSelector([selectGlobalShipXAgencyMappings], (GlobalShipXAgencyMappings) => GlobalShipXAgencyMappings.query);

export const selectGlobalShipXAgencyMappingsCreatedItem = createSelector([selectGlobalShipXAgencyMappings], (GlobalShipXAgencyMappings) => GlobalShipXAgencyMappings.create);

export const selectGlobalShipXAgencyMappingsUpdatedItem = createSelector([selectGlobalShipXAgencyMappings], (GlobalShipXAgencyMappings) => GlobalShipXAgencyMappings.update);

export const selectGlobalShipXAgencyMappingsReadItem = createSelector([selectGlobalShipXAgencyMappings], (GlobalShipXAgencyMappings) => GlobalShipXAgencyMappings.read);

export const selectGlobalShipXAgencyMappingsDeletedItem = createSelector([selectGlobalShipXAgencyMappings], (GlobalShipXAgencyMappings) => GlobalShipXAgencyMappings.delete);

export const selectGlobalShipXAgencyMappingsSearchedItems = createSelector([selectGlobalShipXAgencyMappings], (GlobalShipXAgencyMappings) => GlobalShipXAgencyMappings.search);

export const selectGlobalShipXAgencyMappingsItemsCount = createSelector([selectGlobalShipXAgencyMappings], (GlobalShipXAgencyMappings) => GlobalShipXAgencyMappings.count);

export const selectGlobalShipXAgencyMappingsItemsFilter = createSelector([selectGlobalShipXAgencyMappings], (GlobalShipXAgencyMappings) => GlobalShipXAgencyMappings.filter);